"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = Slider;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function Slider(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_Slider["default"], _extends({}, props, {
      valueLabelDisplay: "auto"
    }))
  );
}

Slider.propTypes = {
  'aria-labelledby': _propTypes["default"].string.isRequired,
  defaultValue: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  getAriaValueText: _propTypes["default"].func.isRequired,
  marks: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Array), _propTypes["default"].bool]).isRequired,
  min: _propTypes["default"].number.isRequired,
  max: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func,
  onChangeCommitted: _propTypes["default"].func,
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),
  step: _propTypes["default"].number,
  valueLabelFormat: _propTypes["default"].func
};
Slider.defaultProps = {
  defaultValue: null,
  disabled: false,
  onChange: function onChange() {},
  onChangeCommitted: function onChangeCommitted() {},
  orientation: 'horizontal',
  step: 1,
  valueLabelFormat: function valueLabelFormat(value) {
    return value;
  }
};